<div class="field">
  <div class="row justify-content-center">
    <div class="col-md-9 col-xs-12 col-sm-8 p-md-0 p-lg-0">
      <div class="amount-field">
        <span class="p-input-icon-right container-input-num">
          <i class="icon-input-num">₽</i>
          <p-inputNumber
            [(ngModel)]="value"
            mode="decimal"
            inputId="currency-rub"
            [disabled]="_isDisabled"
            [useGrouping]="false"
            currency="RUB" locale="ru-RU"> </p-inputNumber>
        </span>

        <div class="amount-field__question">
          <p-button
            *ngIf="value < 850000"
            (click)="op.toggle($event)"
            icon="pi pi-question-circle"
            styleClass="p-button-rounded p-button-text"></p-button>

          <p-overlayPanel #op>
            <div class="amount-field__overlay">
              <p>Согласно требованиям ЦБ РФ, мы будем рассчитывать вашу финансовую нагрузку исходя из указанного
                значения и учитывать ее в принятии решения.</p>
            </div>
          </p-overlayPanel>
        </div>
      </div>
    </div>
  </div>
  <ngx-slider
    [(value)]="value"
    [options]="options"
  ></ngx-slider>
</div>
